module.exports = {
  /**
   * 是否系统布局配置
   */
  showSettings: false,
  /**
   * 是否显示 tagsView
   */
  tagsView: true,
  /**
   * 是否固定头部
   */
  fixedHeader: true,
  /**
   * 是否显示logo
   */
  sidebarLogo: true,
  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production',
  /**
   * 字典请求地址
   */
  dictUrl: process.env.VUE_APP_BASE_API + '/system/dict/data/getDict',
  /**
   * 文件上传地址
   */
  uploadUrl: process.env.VUE_APP_BASE_API + '/common/upload',
  /**
   * 积木模板地址
   */
  jmTemplateUrl: process.env.VUE_APP_BASE_API + '/report/print-template/listPrintTemplateEntry',
  /**
   * 积木 浏览器 打印地址
   */
  // jmPrintUrl: 'http://10.17.4.225:8032',
  // jmPrintUrl: 'http://10.17.4.225:8032',
  jmPrintUrl: process.env.VUE_APP_JIMU_PRINT_URL,
  // jmPrintUrl: 'http://localhost:8032',
  // jmPrintUrl: process.env.VUE_APP_BASE_API,

  /**
   * 站内信配置
   * disabled：是否禁用站内信，默认true-禁用，false-否，true-是
   * url：websocket地址
   */
  'message-websocket': {
    disabled: false,
    // url     : 'ws://' + process.env.VUE_APP_BASE_API + '/websocket/message'
    url: 'ws://localhost:8032/websocket/message'
  },
  /**
   * 首页主题
   * 1：待办任务样式，页面路径：@/views/business/home1/index
   * 2：e-char图表样式，页面路径：@/views/business/home2/index
   * 3：项目自定义，页面路径：@/views/business/home/index
   */
  indexStyle: 1,
  // 是否显示切换部门选择
  isEnableChangeDept: true,
  /**
   * 日期类型列宽值
   */
  datetypewidth: 80,
  /**
   * 时间类型列宽值
   */
  datetimetypewidth: 180,
  /**
   * 状态类型列宽值
   */
  statewidth: 80,
  /**
   * 姓名类型列宽值
   */
  namewidth: 80,
  /**
   * 单据类型名列宽值
   */
  doctypewidth: 100,
  /**
   * 单据编码列宽值
   */
  docnumberwidth: 120,
  /**
   * 供应商名列宽值
   */
  suppliernamewidth: 180,
  /**
   * 客户名列宽值
   */
  customernamewidth: 180,
  /**
   * 工厂名列宽值
   */
  actorynamewidth: 100,
  /**
   * 仓库名列宽值
   */
  whnamewidth: 140,
  /**
   * 物料编码列宽值
   */
  materielcodewidth: 100,
  /**
   * 物料名称·y列宽值
   */
  materielnamewidth: 140,
  /**
   * 物料规格列宽值
   */
  materialsggwidth: 80,
  /**
   * 单位列宽值
   */
  unitwidth: 60,
  /**
   * 单价类型列宽值
   */
  pricetypewidth: 80,
  /**
   * 数值类型列宽值
   */
  valuetypewidth: 80,
  /**
   * 行号列宽值
   */
  lineNumberWidth: 80,
  /**
   * 长文本
   */
  longTextWidth: 220,
  /**
   * 标题列宽值
   */
  titlenamewidth: 220
};